// Generated by Melange

import * as Buhta_cabinet__DashboardContentTemplate from "../../templates/DashboardContentTemplate.js";
import * as Buhta_cabinet__Kassa from "../../grpc/Kassa.js";
import * as Buhta_cabinet__Link from "../../components/html/Link.js";
import * as Buhta_cabinet__OrgDashboardHeader from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeader.js";
import * as Buhta_cabinet__Receipt from "../../components/organisms/Kassa/KKM/Receipt.js";
import * as Buhta_cabinet__ReceiptHeader from "../../components/organisms/Kassa/KKM/ReceiptHeader.js";
import * as Buhta_cabinet__Receipts from "../../components/organisms/Kassa/KKM/Receipts.js";
import * as Buhta_cabinet__ReceiptsHeader from "../../components/organisms/Kassa/KKM/ReceiptsHeader.js";
import * as Buhta_cabinet__Route from "../../Route.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GlobalStateContext from "../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_core__GrpcState from "../../../../../packages/core/lib/GrpcState.js";
import * as Buhta_core__Tenant from "../../../../../packages/core/lib/Tenant.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function ReceiptsPage(Props) {
  let org = Props.org;
  let id = Props.id;
  let openMenu = Props.openMenu;
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const match = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match[0];
  const currentRoute = Buhta_cabinet__Route.ofUrl(Buhta_cabinet__Route.useUrl(undefined));
  const contextRoute = function (route) {
    return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
  };
  const currentUrlStr = Buhta_cabinet__Route.toString(Buhta_cabinet__Route.ofUrl(Buhta_cabinet__Route.useUrl(undefined)));
  const func = Buhta_cabinet__Kassa.KkmManagerService.view;
  const match$1 = Buhta_core__GrpcState.useModel((function (param) {
    return Curry._3(func, param, /* [] */ 0, id);
  }), undefined);
  const dispatch = match$1[1];
  const kkmObj = match$1[0];
  React.useEffect((function () {
    Curry._2(dispatch, undefined, undefined);
  }), [id]);
  let match$2;
  if (/* tag */ typeof currentRoute === "number" || typeof currentRoute === "string") {
    match$2 = [
      false,
      ""
    ];
  } else {
    switch (currentRoute.TAG) {
      case /* Org */ 6 :
        const match$3 = currentRoute._1;
        if (/* tag */ typeof match$3 === "number" || typeof match$3 === "string" || match$3.TAG !== /* Kassa */ 2) {
          match$2 = [
            false,
            ""
          ];
        } else {
          const match$4 = match$3._0._0;
          if (/* tag */ typeof match$4 === "number" || typeof match$4 === "string") {
            match$2 = [
              false,
              ""
            ];
          } else {
            const match$5 = match$4._1;
            if (/* tag */ typeof match$5 === "number" || typeof match$5 === "string" || match$5.TAG !== /* Receipts */ 1) {
              match$2 = [
                false,
                ""
              ];
            } else {
              const id$1 = match$5._0;
              match$2 = /* tag */ typeof id$1 === "number" || typeof id$1 === "string" || id$1.TAG !== /* View */ 0 ? [
                  false,
                  ""
                ] : [
                  true,
                  id$1._0
                ];
            }
          }
        }
        break;
      case /* Admin */ 7 :
        const match$6 = currentRoute._0;
        if (/* tag */ typeof match$6 === "number" || typeof match$6 === "string" || match$6.TAG !== /* Orgs */ 1) {
          match$2 = [
            false,
            ""
          ];
        } else {
          const match$7 = match$6._0;
          if (/* tag */ typeof match$7 === "number" || typeof match$7 === "string") {
            match$2 = [
              false,
              ""
            ];
          } else {
            const match$8 = match$7._1;
            if (/* tag */ typeof match$8 === "number" || typeof match$8 === "string" || match$8.TAG !== /* Kassa */ 2) {
              match$2 = [
                false,
                ""
              ];
            } else {
              const match$9 = match$8._0._0;
              if (/* tag */ typeof match$9 === "number" || typeof match$9 === "string") {
                match$2 = [
                  false,
                  ""
                ];
              } else {
                const match$10 = match$9._1;
                if (/* tag */ typeof match$10 === "number" || typeof match$10 === "string" || match$10.TAG !== /* Receipts */ 1) {
                  match$2 = [
                    false,
                    ""
                  ];
                } else {
                  const id$2 = match$10._0;
                  match$2 = /* tag */ typeof id$2 === "number" || typeof id$2 === "string" || id$2.TAG !== /* View */ 0 ? [
                      false,
                      ""
                    ] : [
                      true,
                      id$2._0
                    ];
                }
              }
            }
          }
        }
        break;
      default:
        match$2 = [
          false,
          ""
        ];
    }
  }
  const viewReceipt = match$2[0];
  const closeReceiptButton = JsxRuntime.jsx(Buhta_cabinet__Link.make, {
    route: contextRoute({
      TAG: /* Kassa */ 2,
      _0: {
        TAG: /* Kkms */ 0,
        _0: {
          TAG: /* Kkm */ 0,
          _0: id,
          _1: {
            TAG: /* Receipts */ 1,
            _0: /* List */ 0
          }
        }
      }
    }),
    children: JsxRuntime.jsx("img", {
      className: "w-5 h-5",
      src: StaticAsset.src("/static/icons/close-20.svg")
    })
  });
  const newSaleButton = typeof kkmObj === "string" || !(kkmObj.NAME === "Data" && kkmObj.VAL.state === "linked") ? null : JsxRuntime.jsxs(Buhta_cabinet__Link.make, {
      route: contextRoute({
        TAG: /* Kassa */ 2,
        _0: {
          TAG: /* Kkms */ 0,
          _0: {
            TAG: /* Kkm */ 0,
            _0: id,
            _1: /* Cashbox */ 4
          }
        }
      }),
      className: "bg-links hover:bg-links-hover active:bg-links-active flex rounded-sm px-3 py-2",
      children: [
        JsxRuntime.jsx("img", {
          src: StaticAsset.src("/static/icons/plus.svg")
        }),
        JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
          className: "ml-1 text-white",
          children: "Новая продажа"
        })
      ],
      urlParams: {
        hd: [
          "return_to",
          currentUrlStr
        ],
        tl: /* [] */ 0
      }
    });
  const header = deviceType === "mobile" ? (
      viewReceipt ? JsxRuntime.jsx(Buhta_cabinet__ReceiptHeader.make, {
          id: id,
          receiptId: match$2[1],
          org: org,
          openMenu: openMenu,
          closeReceiptButton: closeReceiptButton
        }) : JsxRuntime.jsx(Buhta_cabinet__ReceiptsHeader.make, {
          id: id,
          org: org,
          openMenu: openMenu
        })
    ) : JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeader.make, {
      title: "Чеки",
      rightChildren: newSaleButton
    });
  const match$11 = React.useState(function () {
    return false;
  });
  const setMaximizeReceipt = match$11[1];
  const maximizeReceipt = match$11[0];
  return JsxRuntime.jsx(Buhta_cabinet__DashboardContentTemplate.make, {
    header: header,
    children: JsxRuntime.jsx("div", {
      children: JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Buhta_cabinet__Receipts.make, {
            viewReceipt: viewReceipt,
            maximizeReceipt: maximizeReceipt,
            org: org,
            id: id
          }),
          viewReceipt ? JsxRuntime.jsx(Buhta_cabinet__Receipt.make, {
              onMaximize: (function (value) {
                Curry._1(setMaximizeReceipt, (function (param) {
                  return value;
                }));
              }),
              maximizeReceipt: maximizeReceipt,
              kkm: id,
              orgId: org.id
            }) : null
        ],
        className: "flex h-full"
      }),
      className: "flex flex-col w-full"
    })
  });
}

const make = ReceiptsPage;

export {
  make,
}
/* Buhta_cabinet__DashboardContentTemplate Not a pure module */
